/**
 * @namespace Form
 */

import React from 'react';
import classnames from 'classnames';
import { useForm } from './store';
import wrapperComponent from './wrapper';
import NormalForm, { FreeLayoutForm } from './singleForm';
import FormContext from './formContent';
import FormWrapper from './components/container/formWrapper';
import { getSafeRandom } from '@platform/api';
import { throttle, getMultiLang, getSysFieldid, PubSub, isJSON, getGlobalStorage, setGlobalStorage, getAppReqParam, isNewVisual } from '@platform/api';
import { ItemProvider, BaseComponent } from '@platform/template';
import { Tooltip, Tabs, HotKeys, ScrollElement, SettingSideBox, DragHeightCom } from '@platform/base';
import { WithKeyboardChange } from '@platform/base';
import { focusToNext } from './utils/enterkey';
import CardContainer from '../CardContainer/index';
import FormCardContainer from './components/container/FormCardContainer';
import { treeSearch } from './utils/index';
const { useCardContainer } = CardContainer;
const { FormWithKeyboardChange } = WithKeyboardChange;

require('./form.less');

const { TabPane } = Tabs;
const keyMap = {
    nextTabHandler: ['shift+right'],
    prevTabHandler: ['shift+left'],
};
// form变化,表格重新计算标识
const BEFOREFORMCOMPLETE = 'beforeAreaChangeComplete';
const FORMCOMPLETE = 'areaChangeComplete';
// 关键信息区容器路径
const containerPath = 'LowCodeComponents.NCFormCardContainer';
const cardPath = 'LowCodeComponents.NCFormCard';
function uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (getSafeRandom() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

@ItemProvider
@wrapperComponent
@FormWithKeyboardChange
class Form extends BaseComponent {
    constructor(props) {
        super(props);
        const { store, config, name } = props;
        const { setStore, getStore } = store.getInnerHooks();
        // 实例化时 已知表单查询区ID 缓存ID和config
        if (name && store) {
            setStore(['mainId'], name, false);
            setStore(['FormInstance'], this, false);
            if (!getStore('cardContainerStore')) {
                setStore(['cardContainerStore'], useCardContainer(), false);
            }
        }
        this.prevFormHeight = 0;
        // this.renderFlag = false;
        this.state = { prevWidth: '' };
        this.uniqueKey = uuidv4();
        //将布局信息处理下存在store中
        let { isLowCode, isFreeLayout, formArea } = config;
        if (store && isLowCode && isFreeLayout && formArea) {
            if (Array.isArray(formArea)) {
                let formLayouts = [];
                formArea.forEach(form => {
                    if (Array.isArray(form?.node?.props?.children)) {
                        formLayouts.push(...form?.node?.props?.children);
                    }
                });
                setStore('freeLayout', formLayouts, false);
            }
        }
        // 存储一下低代码标识
        if (store && isLowCode) {
            setStore('isLowCode', true, false);
        }
        //表单设置 xiqq
        let formStyleConfig = getGlobalStorage('localStorage', "nccForm");
        this.formStyleConfig = formStyleConfig && JSON.parse(formStyleConfig) || {};
        if (this.formStyleConfig.formupdownstyle) {
            setStore('formtopLayout', 'top', false);
        }
        setStore('titleColor', this.formStyleConfig.formtitlecolor, false);
        setStore('onlyBorderBottom', this.formStyleConfig.formunderlinestyle, false);
        //暂时不加
        setStore('titleFontWeight', this.formStyleConfig.titleFontWeight, false);
        setStore('contentFontWeight', this.formStyleConfig.contentFontWeight, false);
        setStore('foldFontWeight', this.formStyleConfig.foldFontWeight, false);
        setStore('showMainAreaName', this.formStyleConfig.showMainAreaName, false);
        this.getRelationCode();
        window[this.uniqueKey] = store.getInstance();
    }

    // 判断初始化meta
    UNSAFE_componentWillMount() {
        const { store } = this.props;
        const { setJson } = store.getInnerHooks();
        // 初始化多语加载 
        getMultiLang({
            moduleId: "page_form",
            callback: setJson,
        });
    }

    componentDidMount() {
        let { store } = this.props;
        store?.setRef(this);
        // 首项聚焦逻辑
        this.props?.formStatusChanged?.(this.props, store?.getStatus(), { store });
        // 获取缓存
        const { name } = this.props;
        let { appCode = this.appCode, pageCode = this.pageCode } = this.props;
        const { setStore } = store.getInnerHooks();
        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;
        let localStorage = 'form_card_container_expand';
        let form_card_container_expand_localStorage = appCode + '_' + pageCode + '_' + name + '_' + userid;
        let formLocalStorage = JSON.parse(getGlobalStorage('localStorage', localStorage)) || {};
        let isunfold = formLocalStorage[form_card_container_expand_localStorage];
        if (typeof isunfold?.formCardContainerExpandFlag === 'boolean') {
            setStore('formCardContainerExpand', isunfold.formCardContainerExpandFlag, false);
        }
    }

    componentDidUpdate(nextProps, nextState) {
        const { store, formComponentUpdate } = this.props;
        // 客开旧版本的兼容
        if (typeof formComponentUpdate === 'function') {
            const { getStore } = store.getInnerHooks();
            formComponentUpdate({ ...this.state, ...getStore() });
        }
        // 快捷键逻辑
        nextProps.formStatusChanged(nextProps, store.getStatus(), { store });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        delete window[this.uniqueKey];
        this.props.store.clearAllVerify();
        // const { store, name } = this.props;
        // const { getStore } = store.getInnerHooks();
        // let formCardContainerExpandFlag = getStore('formCardContainerExpand');
        // let { appCode = this.appCode, pageCode = this.pageCode } = this.props;
        // let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        // let userData = userDataJSON && JSON.parse(userDataJSON);
        // let userid = userData && userData.userId;
        // let form_card_container_expand_localStorage = 'form_card_container_expand' + appCode + '_' + pageCode + '_' + name + '_' + userid;
        // if(typeof formCardContainerExpandFlag === 'boolean'){
        //     let storage = { formCardContainerExpandFlag };
        //     try {
        //         setGlobalStorage('localStorage', form_card_container_expand_localStorage, JSON.stringify(storage));
        //     } catch (e) {
        //         console.log('浏览器localStorage容量不足');
        //     }
        // }
    }

    getRelationCode = () => {
        let appReqParam = getAppReqParam();
        this.pageCode = appReqParam.pagecode;
        this.appCode = appReqParam.appcode;
    }

    // 快捷键跳到下一个元素逻辑处理
    fastToNext = (store, moduleId, attrcode, opened, itemType) => {
        let { getHotKeyConfig = () => { } } = this.props;
        let { meta, orderOfHotKey, onLastFormEnter } = getHotKeyConfig() || {};
        let formStore = store.getInnerHooks();
        let { getStore, getAllFormItem } = formStore;
        let mainFormId = getStore('mainId');
        // 處理states 數據 TODO 後面可以考慮優化下
        let items = getAllFormItem() || {};
        let states = {
            disabled: {},
            visible: {},
            form: {},
        };

        for (let key in items) {
            let item = items[key];
            states.disabled[item.attrcode] = !!item.disabled;
            states.visible[item.attrcode] = !!item.visible;
            states.form[item.attrcode] = item;
        }

        // console.log(mainFormId, states, moduleId, attrcode, meta, orderOfHotKey, onLastFormEnter, form);
        let params = {
            states,
            meta,
            moduleId,
            attrcode: attrcode,
            head: mainFormId || moduleId,
            formrelation: meta && meta.formrelation ? meta.formrelation[mainFormId || moduleId] : [mainFormId || moduleId],
            orderOfHotKey: orderOfHotKey,
            onLastFormEnter: onLastFormEnter,
            opened: opened,
            itemType,
            formStore,
        };
        focusToNext(params);
    }

    // 获取核心数据的值
    getCardContainerData = (id, formStore, cardContainerStore) => {
        let items = cardContainerStore.getViewMeta(id);
        const { getItemValue, getInnerHooks, getStatus } = formStore;

        const { getJson, getStore } = getInnerHooks();
        const json = getJson();
        const status = getStatus();

        let data = {};
        items.forEach(item => {
            let { attrcode, itemtype, canBeEditedWhenBrowse } = item;
            let currentValue = getItemValue(attrcode);
            let realBrowse = !['switch_browse', 'attachment'].includes(itemtype) && (status === 'browse' && !canBeEditedWhenBrowse);

            if (['checkbox_switch', 'switch', 'switch_browse'].includes(itemtype) && realBrowse) {
                currentValue.display = currentValue.value ? json["page-form-0007"] : json["page-form-0004"];
            }
            data[attrcode] = currentValue;
        });
        return data;
    }

    /**
     * 渲染单个页签下的主表及分组 ，从这里开始区分渲染的是自由布局表单还是原来的表单
     * 改造思路：
     * 1.先抽出来两种模式下公用的视图部分和数据处理部分，封装成一个容器组件复用 。FormCollapse：包括展开收起和渲染singleForm的容器，注意主表区域没有展开收起功能。  
     * 2.FormCollapse组件，根据是不是自由布局模式renderFreeLayoutForm或者renderNormalForm，分别调用的是调用NormalSingleForm组件和FreeLayoutSingleFrom组件。
     * 3.NormalSingleForm和FreeLayoutSingleFrom组件中调用FormInfoGroup或FromItem处理不同模式下的信息分组，表单和核心数据等
     */
    renderForm = tabsId => {
        const { store, name, config = {}, getHotKeyConfig = () => { }, pageScope } = this.props;
        let { meta = {} } = getHotKeyConfig() || {};
        let mainId = tabsId || name;
        // let { layout = '[]' } = meta;
        // layout = isJSON(layout) ? JSON.parse(layout) : [];
        let { flatLayout } = meta;
        let layout = flatLayout || [];
        let formLayout = layout.find(i => i?.props?.moduleId === mainId);
        let corevisible = config.corevisible || formLayout?.props?.corevisible;
        let coregroups = config.coregroups || formLayout?.props?.coregroups;
        let opposite = config.opposite || formLayout?.props?.opposite;
        const { getStore, getJson } = store.getInnerHooks();
        let langJson = getJson();
        let list = [];
        if (tabsId) {
            let groupIds = getStore(['formRelation'])[tabsId];
            if (Array.isArray(groupIds)) {
                list = [tabsId].concat(groupIds);
            } else {
                list = [tabsId];
            }
        } else {
            // ids
            list = getStore(['formList']) || [];
        }

        let status = store.getStatus();
        let cardContainerStore = getStore('cardContainerStore');
        let cardContainerData = this.getCardContainerData(mainId, store, cardContainerStore);
        if (cardContainerStore) {
            cardContainerStore.setStore('visible', status === 'browse', false);
            cardContainerStore.setData({ data: cardContainerData, shouldForceUpdate: false });
        }
        let { underlineBorder = false, showExpand = true } = config;
        let freeLayoutFlag = !!getStore(['freeLayout']);
        // let freeLayoutFlag = false;
        let singleForm = null;
        // 多页签模式 或者编辑态 或者不存在关联表单的关键信息区 不展示展开收起
        let cardContainerId = config.cardContainerId || (corevisible && coregroups?.length && coregroups.filter(x => x.moduleId)) || this.getCardContainerId(name, meta);
        let formDom = <div
            className={classnames({
                'group-form-wrapper': true,
                'underline-border': underlineBorder,
            })}
            id={name}
        >
            <CardContainer langJson={langJson} store={cardContainerStore} id={mainId} pageId={getStore(['pageid'])} visible={status === 'browse'} data={cardContainerData} />
            {freeLayoutFlag ? this.renderFreeLayoutForm(list, mainId) : this.renderNormalForm(list, mainId)}
        </div>;
        // let isunfold = getStore([mainId, 'isunfold']);
        let isunfold = getStore('formCardContainerExpand') ?? true;
        if (tabsId || status !== 'browse' || !cardContainerId || !cardContainerId.length) {
            singleForm = formDom;
        } else {
            singleForm = <>
                <FormCardContainer showContainer={!isunfold || !showExpand}
                    cardContainerId={cardContainerId}
                    store={store} id={mainId}
                    pageId={getStore(['pageid'])}
                    visible={status === 'browse'}
                    meta={meta}
                    layout={layout}
                    pageScope={pageScope}
                    coregroups={coregroups}
                    opposite={opposite}
                >
                    {/* 表单卡片容器 */}
                </FormCardContainer>
                {
                    showExpand ? <DragHeightCom
                        className={"dragHeightComFormCardContainer"}
                        topDom={
                            <div
                                className={classnames({
                                    'group-form-wrapper': true,
                                    'underline-border': underlineBorder,
                                })}
                                id={name}
                            >
                                <CardContainer langJson={langJson} store={cardContainerStore} id={mainId} pageId={getStore(['pageid'])} visible={status === 'browse'} data={cardContainerData} />
                                {freeLayoutFlag ? this.renderFreeLayoutForm(list, mainId) : this.renderNormalForm(list, mainId)}
                            </div>
                        }
                        defaultExpandFlag={isunfold}
                        expandFlag={isunfold}
                        draggable={false}
                        adaptionHeight={true}
                        useCache={false}
                        bottomDom={null}
                        asyncExpand={false}
                        onExpand={this.handleExpand.bind(this)}
                    >
                    </DragHeightCom> : formDom
                }

            </>;
        }
        return singleForm;
    };

    renderNormalForm = (list, mainId) => {
        const { store, name, config = {}, getHotKeyConfig, _runContext } = this.props;
        const { getStore, getSingleForm, getFormItem } = store.getInnerHooks();
        let formColList = [];
        for (let index = 0; index < list.length; index++) {
            const item = list[index];
            let formList = getSingleForm(item);
            if (Array.isArray(formList)) {
                if (item === mainId) {
                    for (let index = 0; index < formList.length; index++) {
                        const element = formList[index];
                        let itemChildren = getFormItem(element);
                        formColList.push(itemChildren);
                    }
                } else {
                    let itemInfo = getStore([item]);
                    itemInfo.children = [];
                    for (let index = 0; index < formList.length; index++) {
                        const element = formList[index];
                        let itemChildren = getFormItem(element);
                        itemInfo.children.push(itemChildren);
                    }
                    formColList.push(itemInfo);
                }
            }
        }
        // limitItemHeight YBP-FI-BUG-6952
        let { showMainAreaName, formLayout = '', align = '', limitItemHeight = false } = config;
        showMainAreaName = showMainAreaName ?? getStore('showMainAreaName') ?? false;
        return (
            <React.Fragment>
                {
                    list.map(item => {
                        // items
                        let list = getSingleForm(item) || [];
                        // 过滤 单表是否所有字段都不显示
                        list = list.filter(e => (getFormItem(e) || {}).visible == true);
                        let rightClassName = classnames({ rightForm: item == name && config && config.headLeftArea && typeof config.headLeftArea === 'function' });
                        return list.length !== 0 && <FormWrapper
                            headLeftArea={item == name && config && config.headLeftArea &&
                                typeof config.headLeftArea === 'function' &&
                                (
                                    <div className="left-defined-area">{config.headLeftArea()}</div>
                                )}
                            showGroupTooltip={config.showGroupTooltip}
                            store={store}
                            mainId={mainId}
                            showMainAreaName={showMainAreaName}
                            name={item}
                            className={rightClassName}
                            fastToNext={this.fastToNext}
                            onOpenChange={config.onOpenChange}
                        >
                            {item == name && config && config.headTopArea &&
                                typeof config.headTopArea === 'function' &&
                                (
                                    <div className="top-defined-area">{config.headTopArea()}</div>
                                )}
                            <NormalForm
                                form={store}
                                name={item}
                                list={list}
                                // 快捷键逻辑
                                fastToNext={(attrcode, itemType) => {
                                    this.fastToNext(store, item, attrcode, undefined, itemType);
                                }}
                                // 快捷键
                                getHotKeyConfig={getHotKeyConfig}
                                // label 位置
                                formLayout={formLayout}
                                // label 对齐方式
                                align={align}
                                limitItemHeight={limitItemHeight}
                                _runContext={_runContext}
                            />
                        </FormWrapper>;
                    })
                }
            </React.Fragment >
        );
    }

    renderFreeLayoutForm = (list, mainId) => {
        const { store, config = {}, getHotKeyConfig, _runContext } = this.props;
        const { getStore, getSingleForm, getFormItem } = store.getInnerHooks();
        let freeLayout = getStore(['freeLayout']);
        let { showMainAreaName, formLayout = '', align = '' } = config;
        showMainAreaName = showMainAreaName ?? getStore('showMainAreaName') ?? false;
        return (
            <React.Fragment>
                {list.map(item => {
                    let formArea, list;
                    //自由布局下是根据layout数据渲染的
                    formArea = treeSearch(freeLayout, node => node.props.name === 'FormArea' && node.props.moduleId === item);
                    list = formArea.props.children.filter(e => !(e.props.name === 'FormItem' && e.props.itemCode && (getFormItem(e.props.itemCode) || {}).visible == false));
                    return list.length !== 0 && <FormWrapper
                        store={store}
                        mainId={mainId}
                        name={item}
                        showMainAreaName={showMainAreaName}
                        className='free-layout-form'
                        fastToNext={this.fastToNext}
                        onOpenChange={config.onOpenChange}
                    >
                        <FreeLayoutForm
                            form={store}
                            name={item}
                            formArea={formArea}
                            list={list}
                            // 快捷键逻辑
                            fastToNext={(attrcode, itemType) => {
                                this.fastToNext(store, item, attrcode, undefined, itemType);
                            }}
                            // 快捷键
                            getHotKeyConfig={getHotKeyConfig}
                            // label 位置
                            formLayout={formLayout}
                            align={align}
                            _runContext={_runContext}
                        />
                    </FormWrapper>;
                })}
            </React.Fragment >
        );
    }

    // 多页签处理
    renderTabForm = () => {
        const { store, config = {}, getHotKeyConfig = () => { }, name, pageScope } = this.props;
        let { meta = {} } = getHotKeyConfig() || {};
        // let { layout = '[]' } = meta;
        // layout = isJSON(layout) ? JSON.parse(layout) : [];
        let { flatLayout } = meta;
        let layout = flatLayout || [];
        const { getStore, getFormTabs, setFormTabs, getSingleForm, getFormItem, getFormRelations } = store.getInnerHooks();
        let mainId = getStore(['mainId']);
        let formLayout = layout.find(i => i?.props?.moduleId === mainId);
        let corevisible = config.corevisible || formLayout?.props?.corevisible;
        let coregroups = config.coregroups || formLayout?.props?.coregroups;
        let opposite = config.opposite || formLayout?.props?.opposite;
        let tabsList = getStore(['tabsId']),
            currentKey = getFormTabs(),
            formRelations = getFormRelations(),
            status = store.getStatus();
        let cardContainerId = config.cardContainerId || (corevisible && coregroups?.length && coregroups.filter(x => x.moduleId)) || this.getCardContainerId(name, meta);
        let { showExpand = true } = config;
        let tabForm = <HotKeys
            keyMap={keyMap}
            handlers={{
                // 切换下一个页签
                nextTabHandler: () => {
                    let index = tabsList.indexOf(currentKey);
                    let nextIndex = index + 1;
                    if (nextIndex > tabsList.length - 1) {
                        nextIndex = 0;
                    }
                    setFormTabs(tabsList[nextIndex]);
                },
                //  切换上一个页签
                prevTabHandler: () => {
                    let index = tabsList.indexOf(currentKey);
                    let prevIndex = index - 1;
                    if (prevIndex < 0) {
                        prevIndex = tabsList.length - 1;
                    }
                    setFormTabs(tabsList[prevIndex]);
                },
            }}
        >
            {tabsList.reduce((child, tabName) => {
                return <ScrollElement name={tabName} id={tabName}>
                    {child}
                </ScrollElement>;
            }, <Tabs
                activeKey={currentKey}
                onChange={i => setFormTabs(i)}
            >
                {tabsList.map(item => {
                    let groups = formRelations[item] || [];
                    let hasEditableField = false, hasErrorField = false;
                    status !== 'browse' && [item, ...groups].some(moduleId => {
                        return getSingleForm(moduleId).some(attrcode => {
                            let itemInfo = getFormItem(attrcode);
                            if (itemInfo.visible && !itemInfo.disabled) {
                                hasEditableField = true;
                            }
                            if (itemInfo.verify === false) {
                                hasErrorField = true;
                            }
                            return hasEditableField && hasErrorField;
                        });
                    });
                    return <TabPane
                        key={item}
                        tab={<div>
                            {hasEditableField && <i className="iconfont icon-yebj"></i>}
                            {getStore([item])['name']}
                            {hasErrorField && <i className="iconfont icon-djgantanhao" ></i>}
                        </div>}
                    >
                        {this.renderForm(item)}
                    </TabPane>;
                })}
            </Tabs>)
            }

        </HotKeys>;
        
        // let isunfold = getStore([mainId, 'isunfold']);
        let isunfold = getStore('formCardContainerExpand') ?? true;
        if (status !== 'browse' || !cardContainerId || !cardContainerId.length) {
            return tabForm;
        } else {
            return (
                <>
                    <FormCardContainer
                        showContainer={!isunfold || !showExpand}
                        cardContainerId={cardContainerId}
                        store={store} id={mainId}
                        pageId={getStore(['pageid'])}
                        visible={status === 'browse'}
                        meta={meta} layout={layout}
                        pageScope={pageScope}
                        coregroups={coregroups}
                        opposite={opposite}>
                        {/* 表单卡片容器 */}
                    </FormCardContainer>
                    {
                        showExpand ? <DragHeightCom
                            className={"dragHeightComFormCardContainer"}
                            topDom={tabForm}
                            defaultExpandFlag={!showExpand || isunfold}
                            expandFlag={!showExpand || isunfold}
                            adaptionHeight={true}
                            useCache={false}
                            bottomDom={null}
                            asyncExpand={false}
                            onExpand={this.handleExpand.bind(this)}
                        >
                        </DragHeightCom> : tabForm
                    }

                </>

            );
        }
    }

    //
    renderDom = () => {
        const { store } = this.props;
        const { getStore } = store.getInnerHooks();
        if (getStore(['isTabsForm'])) {
            return this.renderTabForm();
        } else {
            return this.renderForm();
        }
    }

    getCardContainerId = (name, meta = {}) => {
        // 从模板取表单与关键信息卡片的关联关系，从layout取表单与关键信息区容器的关联关系，再取并集，得到要渲染的 关键信息区容器 moduleId
        let { layout = '[]', corerelation = {} } = meta;
        layout = isJSON(layout) ? JSON.parse(layout) : [];
        let formCardIdArr = corerelation[name] || [];
        let cardContainerItemArr = layout.filter(item => item.path === containerPath) || [];
        let cardContainerIdArr = [];
        formCardIdArr.forEach(formCardId => {
            let formCardItem = layout.find(item => item?.props?.moduleId === formCardId) || {};
            cardContainerItemArr.forEach(cardContainerItem => {
                if (formCardItem.parentId === cardContainerItem.$id && cardContainerItem.props?.moduleId && cardContainerItem?.props?.visible !== false) {
                    // 拿到关键信息区容器 moduleId 再判断下包含的信息卡片有没有visible为true的
                    let cardItemArr = layout.filter(item => item.path === cardPath && item.parentId === cardContainerItem.$id && item?.props?.visible !== false) || [];
                    cardItemArr.length && cardContainerIdArr.push(cardContainerItem.props.moduleId);
                }
            });
        });
        return [...new Set(cardContainerIdArr)];
    }

    // 上下分栏展开收起回调
    handleExpand = flag => {
        const { store, name } = this.props;
        const { setStore } = store.getInnerHooks();
        this.setExpandFlag = true;
        let { appCode = this.appCode, pageCode = this.pageCode } = this.props;
        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;

        let localStorage = 'form_card_container_expand';
        let form_card_container_expand_localStorage = appCode + '_' + pageCode + '_' + name + '_' + userid;
        let formLocalStorage = JSON.parse(getGlobalStorage('localStorage', localStorage)) || {};
        if (typeof flag === 'boolean') {
            let storage = { formCardContainerExpandFlag: flag };
            formLocalStorage[form_card_container_expand_localStorage] = storage;
            try {
                setGlobalStorage('localStorage', localStorage, JSON.stringify(formLocalStorage));
            } catch (e) {
                console.log('浏览器localStorage容量不足');
            }
        }
        setStore('formCardContainerExpand', flag, true);
    }

    render() {
        const { store, config = {}, name, getHotKeyConfig = () => { } } = this.props;
        const { onAfterEvent, onBeforeValueChange, onBeforeEvent, inputChange } = config;
        return (
            <FormContext.Provider value={{ areaId: name, form: store, onAfterEvent, onBeforeValueChange, onBeforeEvent, config, getHotKeyConfig, inputChange }}>
                <div
                    id={`form_${name}`}
                    fieldid={getSysFieldid(`${(config && config.fieldid) || name}_form-area`)}
                    className={`platform-component-form ${isNewVisual() ? 'new-visual':''}`}
                    uniqueKey={this.uniqueKey}
                >
                    {this.renderDom()}
                </div>
            </FormContext.Provider>

        );
    }
}

Form.displayName = 'Form';
Form.useForm = useForm;

export default Form;
